<h1 mat-dialog-title>{{ 'detailed_processing.insign.dialog.title.sms' | translate }}</h1>

<div mat-dialog-content>

    <div class="row no-gutters">
        <div class="col-sm-12">
            <mat-form-field class="full-width">
                <mat-label>{{ data.trans.insign_sms_to | translate }}</mat-label>
                <input id="{{idPrefix}}{{data.trans.insign_sms_to}}"
                       type="text" matInput
                       [formControl]="insign_sms_to"
                       [required]="isCaseDistributionJob">
            </mat-form-field>
        </div>
    </div>

    <div class="row no-gutters">
        <div class="col-sm-12">
            <mat-form-field class="full-width">
                <mat-label>{{ data.trans.insign_sms_body | translate }}</mat-label>
                <textarea id="{{idPrefix}}{{data.trans.insign_sms_body}}"
                          matInput
                          rows="6"
                          [formControl]="insign_sms_body"
                          [required]="isCaseDistributionJob">
                </textarea>
            </mat-form-field>
        </div>
    </div>

</div>

<div mat-dialog-actions align="center">

    <div class="col-sm-6 no-gutters pl-0">
        <button id="{{idPrefix}}btn.cancel" mat-stroked-button color="primary" class="full-width" (click)="close()">{{ 'common.btn.cancel' | translate }}</button>
    </div>

    <div class="col-sm-6 no-gutters pr-0">
        <button id="{{idPrefix}}btn.save" mat-raised-button class="full-width" color="accent" (click)="accept()" [disabled]="!saveBtnEnabled">{{ 'common.btn.ok' | translate }}</button>
    </div>

</div>
